export default __webpack_public_path__ + "static/media/bl-sketch.18145754.jpg";